import { render, staticRenderFns } from "./CertificateEditor.vue?vue&type=template&id=dc02abe4&scoped=true"
import script from "./CertificateEditor.vue?vue&type=script&lang=js"
export * from "./CertificateEditor.vue?vue&type=script&lang=js"
import style0 from "./CertificateEditor.vue?vue&type=style&index=0&id=dc02abe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc02abe4",
  null
  
)

export default component.exports